import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Inject, ViewChild, OnDestroy
} from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { Itab } from '@ispm/shared/interfaces/Itab';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import {
  TabData
} from '@ispm/dynamic-form/interfaces/TabConfiguration';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { has, get, isEqual, cloneDeep , uniqBy} from 'lodash';
import {ConfirmModalLoaderPayload} from '@ispm/layout/classes/confirm-modal-loader-payload';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import {ModalLoaderNgjsService} from '@ispm/layout/services/modal-loader-ngjs.service';
import {TranslateService} from "@ngx-translate/core";
import {EventService} from '@ispm-client/modules/events/services/event.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import {IEvent, IEventMapParam} from "@ispm-client/modules/events/Interfaces";

@Component({
  selector: 'gen-event-tab',
  templateUrl: './event-tab.component.html',
  styleUrls: ['./event-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget()
export class EventTabComponent implements OnInit, OnDestroy, IWidgetItem {

  currentTabTitle: string;
  tabs: Itab[] = [];
  isTabInitialised: boolean = false;
  tabConfig: Array<any> = [];
  tabContainer: Array<TabData> = [];
  popUpMode: boolean = false;
  widgetName: string;
  formData: any[] = [];
  formConfig: any[];
  disabled: boolean = false;
  dataUpdated: boolean = false;
  @Input()
    public data;
  public widgetUpdateValueCallback: (value) => void;
  private _destroyer: Subject<any> = new Subject<any>();

  private currentIndex;

  private enableMessageTimer : number = 10;
  private eventMapParam: IEventMapParam= {
    eventBasedOnDataChange : false
  }

  private selectedEvent: IEvent;
  private eventFormKeyMap = new Map();
  public dataRecieved: boolean[] = [];
  public isdataRecieved: boolean = false;
  public summaryFormId: string;
  public loadNLPValidation: boolean = true;
  public validationFormId: string;
  public defaultActiveTab: string | null = null;
  public dataIndex:number;
  constructor(private _changeDetector: ChangeDetectorRef,
              private _modalLoaderService: ModalLoaderNgjsService,
              private _translate: TranslateService,
              private _eventService: EventService) {
  }

  ngOnInit() {

  }

  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.dataUpdated = false;
    const widgetPayload = _itemConfig.widgetPayload;
    this.widgetName = _itemConfig.name;
    this.popUpMode = widgetPayload.popupMode;
    this.disabled = widgetPayload.disabled;
    this.validationFormId = widgetPayload.tabConfig[1].validationFormId;
    this.defaultActiveTab = widgetPayload?.defaultActiveTab;
    this.setEnableMessageBasedOnDataConfig(widgetPayload);
    this.createTabConfig(widgetPayload.tabConfig);
    this.mapWidgetData();
    this.createTabs();
    // Checking if events current tab title is present for given session to render the event in correct state and tab
    const currentTabName: string | null = this._eventService.currentTabTitle;

    let tabIndex = this.checkDefaultActiveTab();
    const tabConfig = currentTabName ? ( this.tabConfig.find(tabConfigData => currentTabName === tabConfigData.defaultTitle)
      ?? this.tabConfig[tabIndex]) : this.tabConfig[tabIndex];
    this.mapConfigData(tabConfig.config, tabConfig.data, tabConfig.summaryFormId);
    this.dataIndex=widgetPayload.tabConfig[1]?.dataIndex;
    this.performEventMapping();
  }


  set widgetData(widgetData: any) {
    this.data = widgetData;
    this.mapWidgetData();
    if (this.data) {
      const tab = this.tabContainer.find(tabData => this.currentTabTitle === tabData.tabName);
      this.mapConfigData(tab.config, tab.data,tab.summaryFormId);

    }

  }

  /**
   * Method to set variables[enableMessageBasedOnDataChange,enableMessageTimer] from widget payload.
   * @param widgetPayload
   */
  private setEnableMessageBasedOnDataConfig(widgetPayload){
    const enableMessageBasedOnDataChange = "enableMessageBasedOnDataChange";
    let exclusionFields:Array<string> =[];
    if(has(widgetPayload, [enableMessageBasedOnDataChange])){
      if(has(widgetPayload, [enableMessageBasedOnDataChange,"messageTimer"])){
        this.enableMessageTimer = get(widgetPayload, [enableMessageBasedOnDataChange,"messageTimer"]);
      }
      if(has(widgetPayload, [enableMessageBasedOnDataChange,"messageExclusionFields"])){
        exclusionFields = get(widgetPayload, [enableMessageBasedOnDataChange,"messageExclusionFields"]);
      }
      this.eventMapParam = {
        eventBasedOnDataChange : true,
        exclusionKeys: exclusionFields
      }
    }
  }

  get summaryFormData(){
    let index = this.dataIndex;
    let eventData: any;
    if(index){
      return  cloneDeep(get(this.data,`[${index}]`,{}));
    }
    this._eventService.getSelectedEvent().subscribe(data => {
      eventData = data;
    })
    return eventData;


  }

  /**
   * Select selected event from store and perform map operations.
   */
  private performEventMapping(){
    this._eventService.getSelectedEvent().pipe(takeUntil(this._destroyer.asObservable())).subscribe(data =>{
      this.selectedEvent = data
      if(this.eventMapParam.eventBasedOnDataChange) {
        this.eventFormKeyMap = this._eventService.selectedEventMap(this.eventMapParam,
          cloneDeep(this.selectedEvent));
      }
    })
  }

  /**
   * Method to check the tab data updated based on the data in the store.
   */
  private performDataUpdatedCheck() {
    if(this.isdataRecieved && has(this.formData[this.currentIndex], "key")){

      const currentFormData = cloneDeep(this.formData[this.currentIndex]);
      const key:string = currentFormData.key;
      const currentData = currentFormData[key];
      let data = [];
      if(has(currentData, "content")){
        data = get(currentData, "content");
      }else{
        data = currentData;
      }
      if(data !== undefined){
        if(Array.isArray(data)){
          this._eventService.deleteBlankNullValuesForArrays(data, this.eventMapParam.exclusionKeys);
        }else{
          this._eventService.deleteBlankNullValues(data,
            this.eventMapParam.exclusionKeys);
        }
      }
      const dataString = JSON.stringify(data);
      const eventFormData = JSON.stringify(this.eventFormKeyMap.get(key));
      const dataIsSame:boolean = isEqual(dataString, eventFormData);

      if(dataIsSame){
        this.dataUpdated = false;
      }else{
        this.dataUpdated = true;
      }
    }else{
      this.dataUpdated = false;
    }
  }

  /**
   * Here we pass the TabDataStructure and iterate it to get each individual tab data.
   * Each individual tabdata is a array and holds data for each section in the tab.
   * So individual section data is accumulated in the widget data to retain the original data format .
   * @param tabData
   */
  widgetDataUpdate(tabData: any, isFormInit: boolean) {
    const widgetData = [];
    tabData.forEach(
      eachTab => {
        widgetData.push(...eachTab.data);
      });
    this.data = widgetData;
    if (!isFormInit) {
      this.emitUpdate();
    }
  }


  createTabs() {
    this.tabs = [];
    this.tabConfig.forEach(item => {
      const tabFound = this.tabs.some(tab => tab.name === item.defaultTitle);
      if(!tabFound) {
        this.tabs.push({name: item.defaultTitle});
      }
    });
  }

  /**
   * Data is initially sorted based creation time , then grouping is performed based upon the grouping Ids sequence by the grouping service
   * The tabData is emptied and tabMapType is also emptied .
   * tabData manages the  complete details as the name of the tab and the config associated to it with the data .
   * tabMapType manages the tabName associated with it's grouping id .
   */
  mapWidgetData() {

    /**
     * This call to map returns value and the key as id against the first Grouping Attribute.
     */
    this.tabContainer = [];

    this.tabConfig.forEach((item) => {
      const tempData = [];
      if (this.data) {
        item.config.forEach((itemConfig, itemIndex) => {
          tempData.push('');
          for (const itemData of this.data) {
            if (itemData && itemConfig.key === itemData.key) {
              tempData[itemIndex] = itemData;
            }
          }
        });
      } else {
        for (const itemConfig of item.config) {
          tempData.push('');
        }
      }
      this.tabContainer.push({
        tabName: item.defaultTitle,
        config: item.config,
        data: tempData,
        summaryFormId : item.summaryFormId
      });
    });

    if (!this.isTabInitialised) {
      this.initTabs();
    }

  }

  /**
   * Here configuration are mapped and data is mapped of a init tab and the init tab is set as current tab .
   * This sets the initialization as true .
   */
  initTabs() {
    let tabIndex = this.checkDefaultActiveTab();
    if(this.tabContainer.length > 0){

      // Checking if events current tab title is present for given session to render the event in correct state and tab
      const currentTabName: string | null = this._eventService.currentTabTitle;

      const firstTab: TabData = currentTabName ? ( this.tabContainer.find(tabData => currentTabName === tabData.tabName) ??
        this.tabContainer[tabIndex]) : this.tabContainer[tabIndex];
      this.mapConfigData(firstTab.config, firstTab.data, firstTab.summaryFormId);
      this.currentTabTitle = firstTab.tabName;
      this.isTabInitialised = true;
    }
  }


  /**
   * This create the tab config based on the payload,
   * @param payload
   */
  createTabConfig(payload) {
    if (payload) {
      payload.forEach((item) => {
        this.tabConfig.push({
          defaultTitle: item.defaultTitle,
          config: item.forms,
          summaryFormId: item.summaryFormId
        });
      });
      this.tabConfig = uniqBy(this.tabConfig, 'defaultTitle');
    }
  }


  /**
   * Based on the title emitted onChange map the relevant config and data .
   * @param tabTitle
   */
  onTabChange(tabTitle) {
    // Sets the current tab title to render the event in correct state and tab
    this._eventService.currentTabTitle = tabTitle;
    let context = this;
    if (this.currentTabTitle === tabTitle) {
      return;
    } else {
      if (this.dataUpdated) {
        this._modalLoaderService.popupModal('confirm',
          ConfirmModalLoaderPayload.builder()
            .setTitle(this._translate.instant('DISCARD_DATA') || 'Discard Data')
            .setContent(this._translate.instant('UN_SAVED_CHANGES') || 'Unsaved changes have been made to current tab. Would you like to continue (changes will not be saved)?.')
            .setDeclineButtonText('Cancel')
            .setApproveButtonText('Continue'),
          'ALERT').subscribe(response => {
          if (get(response, 'payload') === modalResponse.approve) {
            context.changeTabConfig(tabTitle);
            context.dataUpdated = false;
            this._eventService.setDiscardEventTabData(true);
          }
        });
      } else {
        context.changeTabConfig(tabTitle);
      }
    }
  }


  /**
   * This method is used to segregate the data and associated configs .
   * For example if a tabData has 3 config forms and set of 3 data . These config should be mapped to the data .
   * There there would be 3 objects of configData. This configData is passed to the view for dynamic form.
   * @param config
   * @param data
   */
  mapConfigData(config, data, summaryFormId?:string) {
    this.formConfig = config;
    if (data && !isEqual(this.formData,data)) {
      this.formData = data || [];
    }
    this.summaryFormId = summaryFormId;
  }

  ngOnDestroy(): void {
    this.selectedEvent = null;
    this.formData = null;
    this._destroyer.next();
    this._destroyer.complete();
  }

  onFormInit(data, index) {
    const tabConfig  = this.tabContainer.find(tabData => this.currentTabTitle === tabData.tabName);
    if (!this.formData[index] && data[get(tabConfig, `config[${index}].key`)]) {
      this.updateChanged({ 'form': data}, index, true);
    }
  }

  dataRecievedEvent(validate: boolean, i) {
    this.dataRecieved[i] = validate;
    this.isdataRecieved = this.dataRecieved.every(item => item);
  }

  updateChanged(data, index, isFormInit?: boolean) {
    if (isEqual(JSON.stringify(this.formData[index]), JSON.stringify(data.form))) {
      return;
    }
    let dataIsUpdated = false;
    if(!isFormInit) {
      dataIsUpdated = true;
    }
    if(dataIsUpdated === true && this.eventMapParam.eventBasedOnDataChange){
      this.currentIndex = index;
      setTimeout(() => this.performDataUpdatedCheck(), this.enableMessageTimer);
    }else {
      this.dataUpdated = dataIsUpdated;
    }
    this.formData[index] = cloneDeep(data.form);
    // updating into the  tab data structure
    this.tabContainer.find(tabData => this.currentTabTitle === tabData.tabName).data[index] = this.formData[index];

    if (this.tabContainer.length > 0) {
      /** Update the data of the widget with the latest data of all the tabs in tabContainer*/
      this.widgetDataUpdate(this.tabContainer, isFormInit);
    }
    this._eventService.getIsDiscardEventTabData().take(1).pipe(takeUntil(this._destroyer.asObservable())).subscribe( isDiscardData => {
      if(isDiscardData){
        this._eventService.setDiscardEventTabData(false);
      }
    });

  }

  /**
   * This calls the call back function provided by the widget to update the data into the formInstance of the Widget Component.
   * Therefore if the corresponding dynamic which loads the widget would have subscribed to the changes in the widget.
   */
  emitUpdate() {
    if (this.widgetUpdateValueCallback) {
      this.widgetUpdateValueCallback.apply(this, [this.data]);
    }
  }

  /**
   * Change tab data and config based on selection
   * @param tabTitle
   */
  changeTabConfig(tabTitle) {
    const tabData = this.tabContainer.filter(tabItemData => tabItemData.tabName === tabTitle);
    if (tabData != null && tabData !== undefined && tabData.length > 0) {
      this.currentTabTitle = tabTitle;
      this.mapConfigData(tabData[0].config, tabData[0].data, tabData[0].summaryFormId);
      this._changeDetector.markForCheck();
    }
  }

  cssClassFormat(className: string) {
    return StringUtils.cssClassFormat(className);
  }

  checkDefaultActiveTab(){
    let tabIndex=0;
    if (this.defaultActiveTab && this.tabContainer.length > 0) {
      tabIndex = this.tabContainer.findIndex(tab => tab.tabName === this.defaultActiveTab);
    }
    this._changeDetector.markForCheck();
    return tabIndex ===-1? 0:tabIndex;
  }

}








